export class Usuario {
    id: number;
    nome: string;
    email: string;
	cidade: string;
	bairro: string;
    telefone: number;
	cpf: string;
	dre_siape: number;
	idade: number;
	cor: string;
	sexo: string;
	trabalho: string;
	formacao_id: number;
    curso: string;
	campus: string;
	ano_ingresso: number;
	turno: string;
	moradia: string;
	bolsa: string;
	projeto_pesquisa: string;
	pcd: string;
    senha: string;
    senha_confirmation: string;
    api_token: string;
    perfilsys_id:number;
}



// WEBPACK FOOTER //
// ./src/app/usuario/usuario.ts